<div class="container">
  <div class="row">
    <div class="col message-box-forms warning-message">
      <div class="container">
        <h5>{{title}}</h5>
        <div class="message-box-forms_content">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <a [href]="url" class="btn btn-primary">Retry</a>
  </div>
</div>
